'use strict';

// export this package's api
module.exports = require('./Pagination');


//////////////////
// WEBPACK FOOTER
// ./~/rc-pagination/lib/index.js
// module id = 999
// module chunks = 0